export default "__VITE_ASSET__B61t9g$D__"